// Components==============
import { motion } from 'framer-motion';
import React, { useState } from 'react';
import './PhoneBlock.module.scss';
import { useMediaQ } from 'hooks/useMediaQ';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobile } from '@fortawesome/pro-solid-svg-icons';
import Button from 'components/UI/Button/Button';
import { minHeight, minWidth } from '../SmallScreenWarning/SmallScreenWarning';
// =========================

export default function PhoneBlock() {
    const phoneWidth = 440;
    const phoneHeight = 440;
    const widthBlock = useMediaQ('max', phoneWidth);
    const heightBlock = useMediaQ('max', phoneHeight, false);
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    return (
        <>
            {(widthBlock || heightBlock) && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    styleName="phone-block"
                >
                    <div styleName="inner">
                        <div styleName="image">
                            <img
                                alt="Spiek the dog with a small screen"
                                src="/images/small-screen-warning/spiek-screen.svg"
                            />
                        </div>
                        <div styleName="text">
                            <h3>Je scherm is te klein</h3>
                            <div styleName="paragraph">
                                <p>
                                    Spiek Digitaal is gemaakt voor tablets en
                                    laptops van minimaal {minWidth}x{minHeight}{' '}
                                    pixels. Jouw scherm is momenteel kleiner,
                                    namelijk {windowWidth}x{windowHeight}.
                                </p>
                            </div>
                        </div>
                    </div>
                </motion.div>
            )}
        </>
    );
}
